import {Jurisdiction} from '../countries/constants'

export const tmOwnershipTransferHighlightedJurisdictions = [
  Jurisdiction.UK,
  Jurisdiction.US,
  Jurisdiction.EU,
  Jurisdiction.AU,
  Jurisdiction.CH,
  Jurisdiction.NZ,
]

export const tmOwnershipTransferJurisdictions: Jurisdiction[] = Object.values(Jurisdiction).filter(
  (jurisdiction) => jurisdiction !== Jurisdiction.ER,
)

export type TrademarkOwnershipTransferJurisdiction = typeof tmOwnershipTransferJurisdictions[number]
